import ajax from './axios'
const DEFAULT_BASEURL = 'http://ptisp.daqsoft.com/scapi/api/scapi/'
const JK_BASEURL = 'http://api.test.jkxds.com/'
const api = {
    /**
     * [循环获取栏目的所有子列表]
     */
    getChannelTreeList (params) {
        return ajax({
            baseURL: DEFAULT_BASEURL,
            url: 'app/siteChannel/getTreeListByChannelCode',
            params: Object.assign({...params})
        })
    },
    /**
     * [栏目列表]
     */
    getChannelList (params) {
        return ajax({
            baseURL: DEFAULT_BASEURL,
            url: 'web/siteChannel/list',
            params: Object.assign({...params})
        })
    },
    /**
     * [栏目详情]
     */
    getChannelDesc (params) {
        return ajax({
            baseURL: DEFAULT_BASEURL,
            url: 'web/siteChannel/detail',
            params: Object.assign({...params})
        })
    },
    /**
     * [新闻资讯列表]
     */
    getNewsList (params) {
        return ajax({
            baseURL: DEFAULT_BASEURL,
            url: 'web/news/list',
            params: Object.assign({...params})
        })
    },
    /**
     * [新闻资讯详情]
     */
    getNewsDesc (params) {
        return ajax({
            baseURL: DEFAULT_BASEURL,
            url: 'web/news/detail',
            params: Object.assign({...params})
        })
    },
    /**
     * [提交解决方案咨询信息]
     */
    saveSolutionApply (params) {
        return ajax({
            method: 'post',
            baseURL: JK_BASEURL,
            url: 'application/m/solutionapply/save',
            params: Object.assign({...params})
        })
    },
    /**
     * [提交产品申请试用信息]
     */
    saveProductApply (params) {
        return ajax({
            method: 'post',
            baseURL: JK_BASEURL,
            url: 'application/m/productapply/save',
            params: Object.assign({...params})
        })
    },
    /**
     * [提交工单申请信息]
     */
    saveFormApply (params) {
        return ajax({
            method: 'post',
            baseURL: JK_BASEURL,
            url: 'application/m/formapply/save',
            params: Object.assign({...params})
        })
    },
    /**
     * [提交合作伙伴申请]
     */
    savePartnerapply (params) {
        return ajax({
            method: 'post',
            baseURL: JK_BASEURL,
            url: 'application/m/partnerapply/save',
            params: Object.assign({...params})
        })
    },
    /**
     * [判断登录状态]
     */
    getLoginStatus () {
        return ajax({
            method: 'get',
            baseURL: JK_BASEURL,
            url: 'application/m/pda/isLogin'
        })
    },
    /**
     * [退出登录]
     */
    loginOut () {
        return ajax({
            method: 'get',
            baseURL: JK_BASEURL,
            url: '/auth/logout'
        })
    }
}

export default api
